import { render } from "./Budinglist.vue?vue&type=template&id=296dcfd2&ts=true"
import script from "./Budinglist.vue?vue&type=script&lang=ts"
export * from "./Budinglist.vue?vue&type=script&lang=ts"

import "./Budinglist.vue?vue&type=style&index=0&id=296dcfd2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__